import axios from "axios"

const api = axios.create({
  // Base relativa por padrão: as chamadas saem same-origin (ex.: /api/* via rewrite do
  // Amplify → execute-api). Mantida mesmo sem auth (evita CORS/URL absoluta).
  baseURL: process.env.REACT_APP_ENV_ENDPOINT || "/api"
  // [CONTENÇÃO 2026-07-06] auth desativada — religar no fix-forward.
  // Backend opera sem cookie (guards comentados); não há sessão pra enviar.
  // withCredentials: true
})

// Observabilidade: identifica a sessão do funil em toda chamada (ver backend docs/observabilidade.md).
// Vive no sessionStorage — mesmo ciclo de vida do patientFound: nova aba = nova sessão/funil.
const SESSION_ID_KEY = "obs_session_id"

const getSessionId = () => {
  let id = sessionStorage.getItem(SESSION_ID_KEY)
  if (!id) {
    id = window.crypto && window.crypto.randomUUID
      ? window.crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2)}`
    sessionStorage.setItem(SESSION_ID_KEY, id)
  }
  return id
}

api.interceptors.request.use(config => {
  try {
    config.headers["x-session-id"] = getSessionId()
  } catch (e) {
    // Observabilidade nunca quebra o funil — sem sessionStorage, segue sem o header.
  }
  return config
})

// [CONTENÇÃO 2026-07-06] auth desativada — religar no fix-forward.
// Todo o interceptor de 401→/auth/refresh→retry (+ clear/redirect) está dormente.
// Motivo: qualquer 401 disparava /auth/refresh (rota dormente no backend) → clear+redirect,
// causando loop e o backend não espera cookie nenhum no modo sem-auth.
// --- BLOCO AUTH ORIGINAL (religar no fix-forward) ---
/*
const SILENT_AUTH = ["/auth/login", "/auth/refresh", "/auth/logout", "/auth/me"]
const isSilent = url => !!url && SILENT_AUTH.some(p => url.indexOf(p) !== -1)

let refreshInFlight = null

const clearAuthState = () => {
  sessionStorage.removeItem("patientFound")
  sessionStorage.removeItem("statusSegmais")
  sessionStorage.removeItem("typeTabelaId")
}

const redirectHome = () => {
  if (window.location.pathname !== "/") {
    localStorage.setItem("logout_reason", "expired")
    window.location.href = "/"
  }
}

api.interceptors.response.use(
  response => response,
  async error => {
    const original = error && error.config
    const status = error && error.response && error.response.status
    const errCode =
      error && error.response && error.response.data && error.response.data.err

    if (status !== 401 || !original) return Promise.reject(error)
    if (isSilent(original.url)) return Promise.reject(error)

    if (errCode === "token_expired" && !original._retry) {
      original._retry = true
      try {
        if (!refreshInFlight) {
          refreshInFlight = api.post("/auth/refresh").finally(() => {
            refreshInFlight = null
          })
        }
        await refreshInFlight
        return api(original)
      } catch (refreshErr) {
        clearAuthState()
        redirectHome()
        return Promise.reject(refreshErr)
      }
    }

    clearAuthState()
    redirectHome()
    return Promise.reject(error)
  }
)
*/
// --- FIM BLOCO AUTH ORIGINAL ---

export default api
